import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { createQueryClient } from "nazare-ui/utils";
import { ThemeProvider } from "nazare-ui/utils/theme";

import { router } from "./router";
import { GlobalSearchProvider } from "./global-search-context";
import { PlatformAuthBootstrap } from "./platform-auth-bootstrap";
import { SecondaryHeaderProvider } from "./secondary-header-context";

const queryClient = createQueryClient();

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <PlatformAuthBootstrap>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <SecondaryHeaderProvider>
            <GlobalSearchProvider>
              <RouterProvider router={router} />
            </GlobalSearchProvider>
          </SecondaryHeaderProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </PlatformAuthBootstrap>
  </StrictMode>,
);
